import { Flex, Select, Typography } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { PREFIX } from '@app/constants';
import { useWindowSize } from '@app/hooks';

import { SalePlansTable } from '@pages/SalePlans/components';
import { useSalePlans, useSalesPlansEffects } from '@pages/SalePlans/hooks';

import '@pages/SalePlans/styles/SalePlans.desktop.scss';

const { Title } = Typography;

export const SalePlans = () => {
  const {
    data,
    year,
    newValue,
    isLoading,
    setNewValue,
    setYear,
    hasUserRightForModuleView,
    getSalePlansHandler,
    selectYearHandler,
    yearOptions,
  } = useSalePlans();

  useSalesPlansEffects({
    getSalePlansHandler,
    selectYearHandler,
  });

  const { isMobile } = useWindowSize();

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PREFIX}sale-plans`}>
      <Title
        className="title-container"
        level={4}
        style={{ marginBottom: isMobile ? '-28px' : '0px' }}
      >
        <Flex wrap={true} gap={16} data-testid="sales-plan-for-year">
          <span>План на</span>
          <Select
            style={{ width: 80 }}
            options={yearOptions}
            value={year}
            onChange={setYear}
            popupRender={(menu) => (
              <div data-testid="year-dropdown">{menu}</div>
            )}
            optionRender={(option) => (
              <span data-testid="year-item">{option.label}</span>
            )}
          />
          <span>отчетный год</span>
        </Flex>
      </Title>
      <SalePlansTable
        data={data}
        year={year}
        newValue={newValue}
        loader={isLoading}
        setNewValue={setNewValue}
        updateRegistry={getSalePlansHandler}
      />
    </div>
  );
};
